import React, { useState, useEffect } from "react";
import { Card, Row, Col } from "react-bootstrap";
import Microphone from "/src/assets/images/images_new/MicrophoneCheck.png";
import Permission from "/src/assets/images/images_new/Permission.svg";

const ChromeCheckGlobal = (props) => {
  const [microphone, setMicrophone] = useState(false);
  const [showMicAccess, setShowMicAccess] = useState(false);

  const checkMicPermission = async () => {
      try {
        if (!navigator.mediaDevices?.getUserMedia) {
          console.log("MediaDevices not supported");
          setMicrophone(false);
          return;
        }
  
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
  
        console.log("Permission Granted");
        setMicrophone(true);
        setShowMicAccess(false);
        // VERY IMPORTANT
        stream.getTracks().forEach(track => track.stop());
  
      } catch (error) {
        console.log("Error name:", error.name);
        console.log("Error message:", error.message);
        setMicrophone(false);
        setShowMicAccess(true);
      }
      props.updateMicrophonePermission(microphone)
    };
  
    useEffect(() => {
      // navigator.mediaDevices.getUserMedia({ audio: true }, () => {
      // 	console.log('Permission Granted');
      // 	setMic(true);
      // }, (error) => {
      // 	console.log('Permission Denied', error);
      // 	setMic(false);
      // });
      // if (navigator.mediaDevices.getUserMedia === undefined) {
      // 	setMic(false);
      // } else {}
      checkMicPermission();
    }, []);

  return (
    <>
      <div className="content py-4 checkGlobalPage">
        <h2>Requirements { microphone ? (<span className='text-info'>satisfied</span>) : (<span className='text-danger'>not satisfied</span>)}</h2>
        <Row className="m-1 m-lg-0">
          <div className="col-12 col-xl-6">
            <Card className={`${microphone ? 'text-info' : 'text-danger'}`} style={{ borderTop: '15px solid' }}>
              <Card.Header>
                <Card.Title tag="h4">
                  <i className="fa fa-microphone"></i>&nbsp;&nbsp;&nbsp;Microphone
                </Card.Title>
                <Card.Subtitle>This test requires a microphone connected to your system.</Card.Subtitle>
              </Card.Header>
              <Card.Body>
                {microphone ? (
                  <React.Fragment>
                    <i className="bx bx-check-circle"></i>
                    <em>*Microphone detected on your device.</em>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <i className="bx bx-x-circle"></i>
                    <em>*We could not find any microphone connected to your device. Please connect microphone and refresh page.</em>
                    <button onClick={checkMicPermission} className="align-items-center btn d-flex m-0 mt-3">Enable Microphone</button>
                  </React.Fragment>
                )}
              </Card.Body>
            </Card>
          </div>
          {showMicAccess && (
          <Col xs={12} xl={6}>
            <Card>
            <Card.Header>
              <Card.Title as="h4">Microphone Access Required</Card.Title>
            </Card.Header>
            <Card.Body className="text-center">

              <div 
                style={{
                gap: "20px",
                marginTop: "20px",
                padding: "20px",
                backgroundColor: "#f8f9fa",
                borderRadius: "8px",
                textAlign: "left"
                }}
                className="d-flex flex-column flex-md-row"
              >
                <div style={{ flexShrink: 0 }}>
                <img 
                  src={Microphone} 
                  alt="Microphone" 
                  style={{ width: "200px", height: "200px", objectFit: "contain" }}
                />
                </div>
                <div style={{ flex: 1 }}>
                {/* <h5 style={{ marginTop: 0 }}>Microphone Access Required</h5> */}
                <p style={{ marginBottom: "10px" }}>
                  It looks like the microphone is blocked or not enabled in your browser.
                </p>
                <h6>Steps to enable microphone access:</h6>
                <ol style={{ marginBottom: 0, paddingLeft: "20px" }}>
                  <li>1. Click the <strong>page <img src={Permission} alt="Permission" style={{ width: "20px", height: "20px", objectFit: "contain" }} /> icon</strong> in your browser's address bar</li>
                  <li>2. Turn <strong>Microphone access ON</strong> for this site</li>
                  <li>3. <strong>Refresh the page</strong> and try again</li>
                </ol>
                </div>
              </div>
            </Card.Body>
            </Card>
          </Col>
          // <Row style={{ marginTop: "30px" }}>
          // </Row>			
          )}          
        </Row>
      </div>
    </>
  );
};

export default ChromeCheckGlobal;